(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const form = document.querySelector('.product-form');
    if (!form) return;

    const selects = form.querySelectorAll('.product-form__select[name^="options"]');
    const idInput = form.querySelector('input[name="id"]');
    if (!idInput || selects.length === 0) return;

    const scriptEl = form.querySelector('script[type="application/json"]');
    let variants = [];
    if (scriptEl) {
      try {
        variants = JSON.parse(scriptEl.textContent || '[]');
      } catch (e) {}
    }

    function getSelectedOptions() {
      const selected = [];
      selects.forEach(function (s) {
        selected.push(s.value);
      });
      return selected;
    }

    function findVariant() {
      const selected = getSelectedOptions();
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === selected[i];
        });
      });
    }

    function updateForm(variant) {
      if (!variant) return;
      idInput.value = variant.id;
      const submitBtn = form.querySelector('.product-form__submit-btn');
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available
          ? submitBtn.getAttribute('data-add-to-cart')
          : submitBtn.getAttribute('data-sold-out');
      }
    }

    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        const variant = findVariant();
        updateForm(variant);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
